export const vacancies = [
  {
    id: 1,
    title: "Verpleegkundig begeleider in de gehandicaptenzorg, Regio Arnhem",
    description:
      "Ben jij een zorgprofessional met een hart voor mensen met een beperking? Wil jij het verschil maken in hun dagelijks leven? Exactzorg, hét uitzend- en bemiddelingsbureau voor de zorg, is op zoek naar betrokken en deskundige Verpleegkundig begeleider in de gehandicaptenzorg.",
    location: "Arnhem",
    province: "Gelderland",
    hours: "1 - 36 uur",
    salary: "€2670 - €4350",
    lat: 51.9854,
    lng: 5.8987,
    info: "Detachering, Uitzendkracht, Oproep-Flexpool",
    education: "MBO4, HBO",
    experience: "0",
  },
  {
    id: 2,
    title: "Begeleider EVB en EMB in Oosterhout",
    description:
      "Exactzorg is op zoek naar een begeleider voor cliënten met een ernstige en meervoudige beperking voor een periode opdracht. Je komt te werken in een warme en betrokken omgeving waarin jij écht iets kunt betekenen. Jij bent degene die structuur, veiligheid en plezier brengt in het leven van onze bewoners.",
    location: "Oosterhout",
    province: "Noord-Brabant",
    hours: "8 - 36 uur",
    salary: "€2450 - €3680",
    lat: 51.6341,
    lng: 4.859,
    info: "Detachering, Uitzendkracht, Oproep-Flexpool",
    education: "MBO 3, MBO4, HBO",
    experience: "0",
  },
  {
    id: 3,
    title: "Verpleegkundig begeleider in de gehandicaptenzorg, Regio Waalwijk",
    description:
      "Ben jij een zorgprofessional met een hart voor mensen met een beperking? Wil jij het verschil maken in hun dagelijks leven? Exactzorg, hét uitzend- en bemiddelingsbureau voor de zorg, is op zoek naar betrokken en deskundige verpleegkundig begeleider in de gehandicaptenzorg.",
    location: "Waalwijk",
    province: "Noord-Brabant",
    hours: "1 - 36 uur",
    salary: "€2670 - €4350",
    lat: 51.6825,
    lng: 5.0706,
    info: "Detachering, Uitzendkracht, Oproep-Flexpool",
    education: "MBO 4, HBO",
    experience: "0",
  },
  {
    id: 4,
    title: "Verzorgende IG woonzorglocaties GHZ in Waalwijk en omgeving",
    description:
      "Ben jij een gedreven Verzorgende IG die GHZ cliënten helpt hun dag goed te beginnen en hen ondersteunt bij hun zorgbehoeften? Zoek je een flexibele baan waarin jij bepaalt waar en wanneer je werkt? Sluit je aan bij Exactzorg en maak het verschil voor cliënten in Waalwijk en omgeving!",
    location: "Waalwijk en omgeving",
    province: "Noord-Brabant",
    hours: "8 - 36 uur",
    salary: "€2390 - €3940",
    info: "Uitzendkracht",
    lat: 51.6825,
    lng: 5.0706,
    education: "MBO 3",
    experience: "0",
  },
  {
    id: 5,
    title: "Verzorgende IG woonzorglocaties GHZ in Tilburg en omgeving",
    description:
      "Ben jij een gedreven Verzorgende IG die GHZ cliënten helpt hun dag goed te beginnen en hen ondersteunt bij hun zorgbehoeften? Zoek je een flexibele baan waarin jij bepaalt waar en wanneer je werkt? Sluit je aan bij Exactzorg en maak het verschil voor cliënten in Tilburg en omgeving!",
    location: "Tilburg en omgeving",
    province: "Noord-Brabant",
    hours: "8 - 36 uur",
    salary: "€2390 - €3940",
    info: "Uitzendkracht",
    lat: 51.5555,
    lng: 5.0913,
    education: "MBO 3",
    experience: "0",
  },
  {
    id: 6,
    title: "Verzorgende IG woonzorglocaties GHZ in Breda en omgeving",
    description:
      "Ben jij een gedreven Verzorgende IG die GHZ cliënten helpt hun dag goed te beginnen en hen ondersteunt bij hun zorgbehoeften? Zoek je een flexibele baan waarin jij bepaalt waar en wanneer je werkt? Sluit je aan bij Exactzorg en maak het verschil voor cliënten in Breda en omgeving!",
    location: "Breda en omgeving",
    province: "Noord-Brabant",
    hours: "8 - 36 uur",
    salary: "€2390 - €3940",
    info: "Uitzendkracht",
    lat: 51.5719,
    lng: 4.7683,
    education: "MBO 3",
    experience: "0",
  },
  {
    id: 7,
    title: "Verpleegkundige woonzorglocaties GHZ in Waalwijk en omgeving",
    description:
      "Ben jij een gedreven Verpleegkundige die cliënten met een beperking de zorg en ondersteuning biedt die ze verdienen? Wil je werken in een flexibele rol waarin jij bepaalt waar en wanneer je werkt? Kom werken bij Exactzorg en maak een verschil in Waalwijk en omgeving!",
    location: "Waalwijk en omgeving",
    province: "Noord-Brabant",
    hours: "8 - 36 uur",
    salary: "€2670 - €4350",
    info: "Uitzendkracht",
    education: "MBO 4, HBO",
    lat: 51.6825,
    lng: 5.0706,
    experience: "0",
  },
  {
    id: 8,
    title: "Verpleegkundige woonzorglocaties GHZ in Tilburg en omgeving",
    description:
      "Ben jij een gedreven Verpleegkundige die cliënten met een beperking de zorg en ondersteuning biedt die ze verdienen? Wil je werken in een flexibele rol waarin jij bepaalt waar en wanneer je werkt? Kom werken bij Exactzorg en maak een verschil in Tilburg en omgeving!",
    location: "Tilburg en omgeving",
    province: "Noord-Brabant",
    hours: "8 - 36 uur",
    salary: "€2670 - €4350",
    info: "Uitzendkracht",
    lat: 51.5555,
    lng: 5.0913,
    education: "MBO 4, HBO",
    experience: "0",
  },
  {
    id: 9,
    title: "Verpleegkundige woonzorglocaties GHZ in Breda en omgeving",
    description:
      "Ben jij een gedreven Verpleegkundige die cliënten met een beperking de zorg en ondersteuning biedt die ze verdienen? Wil je werken in een flexibele rol waarin jij bepaalt waar en wanneer je werkt? Kom werken bij Exactzorg en maak een verschil in Breda en omgeving!",
    location: "Tilburg en omgeving",
    province: "Noord-Brabant",
    hours: "8 - 36 uur",
    salary: "€2670 - €4350",
    info: "Uitzendkracht",
    lat: 51.5719,
    lng: 4.7683,
    education: "MBO 4, HBO",
    experience: "0",
  },
  {
    id: 10,
    title: "Verpleegkundige woonzorglocaties GHZ in Waalwijk en omgeving",
    description:
      "Wij zoeken enthousiaste Begeleiders GHZ die graag zorgen voor cliënten met een lichamelijke en/of verstandelijke beperking in Waalwijk en de omliggende dorpen. Als uitzendkracht bij Exactzorg bepaal jij zelf op welke locaties en tijdens welke diensten je werkt, zodat je maximale flexibiliteit hebt in je werkrooster.",
    location: "Waalwijk en omgeving",
    province: "Noord-Brabant",
    hours: "8 - 36 uur",
    salary: "€2340 - €3940",
    info: "Uitzendkracht",
    lat: 51.6825,
    lng: 5.0706,
    education: "MBO 3, MBO 4",
    experience: "0",
  },
  {
    id: 11,
    title: "Verpleegkundige woonzorglocaties GHZ in Tilburg en omgeving",
    description:
      "Wij zoeken enthousiaste Begeleiders GHZ die graag zorgen voor cliënten met een lichamelijke en/of verstandelijke beperking in Tilburg en de omliggende dorpen. Als uitzendkracht bij Exactzorg bepaal jij zelf op welke locaties en tijdens welke diensten je werkt, zodat je maximale flexibiliteit hebt in je werkrooster.",
    location: "Tilburg en omgeving",
    province: "Noord-Brabant",
    hours: "8 - 36 uur",
    salary: "€2390 - €3940",
    info: "Uitzendkracht",
    lat: 51.5555,
    lng: 5.0913,
    education: "MBO 3, MBO 4",
    experience: "0",
  },
  {
    id: 12,
    title: "Verpleegkundige woonzorglocaties GHZ in Breda en omgeving",
    description:
      "Wij zoeken enthousiaste Begeleiders GHZ die graag zorgen voor cliënten met een lichamelijke en/of verstandelijke beperking in Breda en de omliggende dorpen. Als uitzendkracht bij Exactzorg bepaal jij zelf op welke locaties en tijdens welke diensten je werkt, zodat je maximale flexibiliteit hebt in je werkrooster.",
    location: "Breda en omgeving",
    province: "Noord-Brabant",
    hours: "8 - 36 uur",
    salary: "€2390 - €3940",
    info: "Uitzendkracht",
    lat: 51.5719,
    lng: 4.7683,
    education: "MBO 3, MBO 4",
    experience: "0",
  },
  {
    id: 13,
    title: "Verpleegkundige Gehandicaptenzorg, regio Gelderland",
    description:
      "Elke dienst biedt andere en nieuwe uitdagingen. Je werkt met verschillende doelgroepen die elk een andere zorg en begeleidingsstijl van je vragen. Op dit moment zoeken we Verpleegkundigen in de regio Gelderland. Iets voor jou?",
    location: "Arnhem",
    province: "Gelderland",
    hours: "8 - 36 uur",
    salary: "€2820 - €4350",
    info: "Uitzendkracht",
    lat: 51.9851,
    lng: 5.8987,
    education: "MBO 4, HBO",
    experience: "0",
  },
  {
    id: 14,
    title: "Verzorgende IG Gehandicaptenzorg, regio Gelderland",
    description:
      "In de rol van Verzorgende IG Gehandicaptenzorg zorg je samen met je collega’s voor mensen met een beperking. Dit doe je door de zorg te organiseren, contact met familie te onderhouden en door bij te dragen aan een fijne dag voor cliënten. Op dit moment zoeken we Verzorgenden IG in de regio Gelderland. Iets voor jou?",
    location: "Arnhem",
    province: "Gelderland",
    hours: "8 - 36 uur",
    salary: "€2670 - €3610",
    lat: 51.9858,
    lng: 5.8987,
    info: "Uitzendkracht",
    education: "MBO 3, MBO 4",
    experience: "0",
  },
  {
    id: 15,
    title: "Persoonlijk Begeleider Gehandicaptenzorg, regio Gelderland",
    description:
      "In de rol van Persoonlijk Begeleider Gehandicaptenzorg zorg je samen met je collega’s voor mensen met een beperking. Dit doe je door de zorg te organiseren, contact met familie te onderhouden en door bij te dragen aan een fijne dag voor cliënten. Op dit moment zoeken we Persoonlijk Begeleiders in de regio Gelderland. Iets voor jou?",
    location: "Arnhem",
    province: "Gelderland",
    hours: "8 - 36 uur",
    salary: "€2390 - €3600",
    info: "Uitzendkracht",
    lat: 51.986,
    lng: 5.8987,
    education: "MBO 2, MBO 3",
    experience: "0",
  },
  {
    id: 16,
    title: "Helpende Gehandicaptenzorg, regio Gelderland",
    description:
      "Als Helpende werk je ondersteunend aan bewoners en begeleiders in de gehandicaptenzorg. Je pakt taken op in het huishouden, creëert een fijne sfeer door de woning gezellig te maken en onderneemt activiteiten samen met bewoners. Op dit moment zoeken we Helpenden in regio Gelderland. Iets voor jou?",
    location: "Arnhem",
    province: "Gelderland",
    hours: "8 - 36 uur",
    salary: "€2150 - €3130",
    lat: 51.9862,
    lng: 5.8987,
    info: "Uitzendkracht",
    education: "MBO 2",
    experience: "0",
  },
  {
    id: 17,
    title: "ZZP begeleider zorg en gedrag",
    description:
      "Voor een zorgorganisatie zoeken wij een begeleider die graag zowel begeleiding als verzorging biedt aan bewoners met diverse zorgbehoeften. Geen dag is hetzelfde, en je gaat elke dag met voldoening naar huis.",
    location: "Eindhoven",
    province: "Noord-Brabant",
    hours: "8 - 32 uur",
    lat: 51.4416,
    lng: 5.4697,
    salary: "€40 - €50",
    info: "ZZP",
    education: "MBO 3, MBO 4",
    experience: "0",
  },
  {
    id: 18,
    title: "ZZP Begeleider gehandicaptenzorg, gedrag en zorg",
    description:
      "Bij deze organisatie staan eigen regie en persoonlijk contact centraal. Ze luisteren naar de wensen van de cliënten en bieden ondersteuning op maat, van thuiszorg tot dagbesteding en innovatieve woonvormen.",
    location: "Kaatsheuvel",
    province: "Noord-Brabant",
    hours: "8 - 36 uur",
    lat: 51.653,
    lng: 5.0463,
    salary: "€40 - €50",
    info: "ZZP",
    education: "MBO 3, MBO 4, HBO",
    experience: "0",
  },
  {
    id: 19,
    title: "ZZP Begeleider gehandicaptenzorg, gedrag en zorg",
    description:
      "Ben jij een gedreven Verzorgende IG en werk je graag als zorgprofessional in de gehandicaptenzorg? Bij Exact Zorg heb jij de regie in handen en bepaal je zelf welke diensten je invult. Of je nu kiest voor langere opdrachten of liever flexibel aan de slag gaat, wij bieden de ruimte om te werken op jouw manier.",
    location: "Tilburg",
    province: "Noord-Brabant",
    hours: "8 - 36 uur",
    salary: "€40 - €50",
    lat: 51.5555,
    lng: 5.0913,
    info: "ZZP",
    education: "MBO 3",
    experience: "0",
  },
  {
    id: 20,
    title: "ZZP Verzorgende IG begeleider gehandicaptenzorg",
    description:
      "Ben jij een gedreven Verzorgende IG en werk je graag als zorgprofessional in de gehandicaptenzorg? Bij Exact Zorg heb jij de regie in handen en bepaal je zelf welke diensten je invult. Of je nu kiest voor langere opdrachten of liever flexibel aan de slag gaat, wij bieden de ruimte om te werken op jouw manier.",
    location: "Eindhoven",
    province: "Noord-Brabant",
    hours: "8 - 36 uur",
    salary: "€40 - €50",
    lat: 51.4416,
    lng: 5.4697,
    info: "ZZP",
    education: "MBO 3",
    experience: "0",
  },
];
